import { useMemo } from 'react'

/**
 * Get responsive title CSS classes based on title length
 *
 * Longer titles get smaller font sizes to prevent overflow.
 * Returns Tailwind classes for responsive typography.
 */
export function useTitleClasses(title: string): string {
  return useMemo(() => {
    const len = title.length
    if (len > 200) {
      return 'text-lg md:text-xl font-bold leading-snug tracking-tight'
    }
    if (len > 120) {
      return 'text-xl md:text-2xl font-bold leading-snug tracking-tight'
    }
    return 'text-2xl md:text-3xl font-bold leading-tight tracking-tight'
  }, [title])
}
